import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import ArrowLeftIcon from '@/assets/icons/arrow-left.svg?react'
import { ButtonRadio, Divider, Trans } from '@/components'
import { EmptyView } from '@/components/EmptyView'
import { EIPBreadcrumb } from '@/pages/eip/components/EIPBreadcrumb'

type TimeRange = 'all' | '1d' | '7d' | '30d'

export function RouteMonitorDetailPage() {
  const { t } = useTranslation('modelRoute')
  const navigate = useNavigate()
  const { routeResId } = useParams<{ routeResId: string }>()
  const routeId = routeResId ?? ''

  const [range, setRange] = useState<TimeRange>('all')

  return (
    <div className="card bg-panel-white h-full overflow-y-auto">
      <div className="flex items-center justify-between h-[60px]">
        <div className="flex items-center gap-3">
          <button
            type="button"
            className="text-tertiary cursor-pointer hover:text-primary"
            onClick={() => navigate('/model-route')}
            aria-label="back"
          >
            <ArrowLeftIcon className="w-5 h-5" />
          </button>
          <EIPBreadcrumb
            items={[
              {
                label: (
                  <Trans ns="modelRoute" i18nKey="title">
                    Model Route
                  </Trans>
                ),
                to: '/model-route',
              },
              {
                label: t('monitorDetail.title', '{{id}} - Monitor Detail', { id: routeId }),
                to: `/model-route/${routeId}/monitor`,
                active: true,
              },
            ]}
          />
        </div>
        <ButtonRadio
          size="small"
          value={range}
          items={[
            { label: t('monitorDetail.rangeAll', 'All Time'), value: 'all' },
            { label: t('monitorDetail.range1d', '1 day'), value: '1d' },
            { label: t('monitorDetail.range7d', '7 day'), value: '7d' },
            { label: t('monitorDetail.range30d', '30 days'), value: '30d' },
          ]}
          onChange={setRange}
        />
      </div>

      <Divider />

      {/* TODO(model-route-api): metric cards + usage charts — the data source is ready
          (CanvasAPI.getRouteMonitorMetrics), chart design pending */}
      <div className="mt-4">
        <EmptyView
          title={
            <span className="t-sm text-secondary">
              <Trans ns="modelRoute" i18nKey="monitorDetail.chartsComingSoon">
                Charts coming soon
              </Trans>
            </span>
          }
        />
      </div>
    </div>
  )
}
